import { Flex, Skeleton, VStack } from '@chakra-ui/react';

const SkeletonCard = () => {
  const skeletonProps = {
    borderRadius: 'radius-4',
    endColor: 'grey.200',
    height: '8px',
    startColor: 'grey.100',
  };
  return (
    <VStack
      alignItems="flex-start"
      border="1px solid"
      borderColor="grey.200"
      borderRadius="radius-8"
      marginBottom="space-16"
      padding="space-16"
      spacing="space-16"
    >
      <Flex justifyContent="space-between" width="100%">
        <Skeleton width="50%" {...skeletonProps} />
        <Skeleton width="20%" {...skeletonProps} />
      </Flex>
      <Skeleton width="30%" {...skeletonProps} />
    </VStack>
  );
};

export default SkeletonCard;
